export default {
  data() {
    return {
      isMobile: window.innerWidth < 992,
    };
  },

  created() {
    this.onResizeWindowGlobal = this.onResizeWindowGlobal();

    window.addEventListener('resize', this.onResizeWindowGlobal);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResizeWindowGlobal);
  },

  methods: {
    toggleClasses(flag, cssClass) {
      cssClass = cssClass || 'full-height';

      const nodes = [
        document.documentElement,
        document.body,
        document.getElementById('app'),
      ];

      if (flag) {
        nodes.forEach((item) => {
          item.classList.add(cssClass);
        });
      } else {
        nodes.forEach((item) => {
          item.classList.remove(cssClass);
        });
      }
    },

    animate(options) {
      const start = performance.now();

      const {
        duration,
        timing = linear,
        draw,
      } = options;

      requestAnimationFrame(animate);

      /**
       * @param {Number} timeFraction
       * @return {Number}
       */
      function linear(timeFraction) {
        return timeFraction;
      }

      /**
       * @param {Number} time
       */
      function animate(time) {
        let timeFraction = (time - start) / duration;

        if (timeFraction > 1) {
          timeFraction = 1;
        }

        const progress = timing(timeFraction);

        draw(progress);

        if (timeFraction < 1) {
          requestAnimationFrame(animate);
        }
      }
    },

    onResizeWindowGlobal() {
      let prevWidth = window.innerWidth;

      return () => {
        const currWidth = window.innerWidth;

        if (currWidth >= 992 && prevWidth < 992) {
          this.isMobile = false;
        } else if (currWidth < 992 && prevWidth >= 992) {
          this.isMobile = true;
        }

        prevWidth = currWidth;
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Utils.js